// extracted by mini-css-extract-plugin
export default {"coverLink":"IO-z","contentBox":"JO-z","zapposPromoContainer":"KO-z","zapposPromoGroupContainer":"LO-z","promos":"MO-z","bottom":"NO-z","top":"OO-z","right":"PO-z","left":"QO-z"};